import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { DocTemplateListPayload } from '~bank-document-templates/types'

export const TEMPLATES_LIST_KEY = 'templatesList'

export const templatesListQueryOptions = (deps: Partial<Omit<DocTemplateListPayload, 'id'>>) =>
  queryOptions({
    queryKey: [TEMPLATES_LIST_KEY, deps],
    queryFn: () => Request.post(Request.urls.bank.documentTemplateList, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
